import { blogArticles, blogCategories } from '../data/blogArticles';

class BlogService {
  // Get all blog articles
  getAllArticles() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          data: blogArticles,
          total: blogArticles.length
        });
      }, 500); // Simulate API delay
    });
  }

  // Get articles by category
  getArticlesByCategory(category) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const filteredArticles = category === 'All Articles' 
          ? blogArticles 
          : blogArticles.filter(article => article.category === category);
        
        resolve({
          success: true,
          data: filteredArticles,
          total: filteredArticles.length
        });
      }, 300);
    });
  }

  // Get featured articles
  getFeaturedArticles() {
    return new Promise((resolve) => {
      setTimeout(() => {
        const featuredArticles = blogArticles.filter(article => article.featured);
        resolve({
          success: true,
          data: featuredArticles,
          total: featuredArticles.length
        });
      }, 300);
    });
  }

  // Get single article by ID
  getArticleById(id) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const article = blogArticles.find(article => article.id === parseInt(id));
        if (article) {
          resolve({
            success: true,
            data: article
          });
        } else {
          resolve({
            success: false,
            error: 'Article not found'
          });
        }
      }, 200);
    });
  }

  // Get all categories
  getCategories() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          data: blogCategories
        });
      }, 100);
    });
  }

  // Search articles
  searchArticles(query) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const searchResults = blogArticles.filter(article => 
          article.title.toLowerCase().includes(query.toLowerCase()) ||
          article.excerpt.toLowerCase().includes(query.toLowerCase()) ||
          article.tags.some(tag => tag.toLowerCase().includes(query.toLowerCase()))
        );
        
        resolve({
          success: true,
          data: searchResults,
          total: searchResults.length
        });
      }, 400);
    });
  }
}

export default new BlogService();
